import { render, staticRenderFns } from "./NotificacaoConfirmar.vue?vue&type=template&id=29c222d8&scoped=true&"
import script from "./NotificacaoConfirmar.vue?vue&type=script&lang=js&"
export * from "./NotificacaoConfirmar.vue?vue&type=script&lang=js&"
import style0 from "./NotificacaoConfirmar.vue?vue&type=style&index=0&id=29c222d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c222d8",
  null
  
)

export default component.exports